import { Navigate } from 'react-router-dom';
import { pb } from '../lib/pocketbase';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

interface UserModel {
  id: string;
  email: string;
  name?: string;
  avatar?: string;
  role_level: number;
  created: string;
  updated: string;
}

export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const user = pb.authStore.model as unknown as UserModel | null;
  console.log('Protected Route - Full User Object:', user);
  console.log('Protected Route - Role Level:', user?.role_level);

  // Check if user has admin role (role_level 1)
  const isAdmin = user?.role_level === 1;

  if (!isAdmin) {
    console.log('Protected Route - Redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
